import { render, staticRenderFns } from "./Family-statement-notification-assignment-search.vue?vue&type=template&id=71227061&scoped=true"
import script from "./Family-statement-notification-assignment-search.vue?vue&type=script&lang=js"
export * from "./Family-statement-notification-assignment-search.vue?vue&type=script&lang=js"
import style0 from "./Family-statement-notification-assignment-search.vue?vue&type=style&index=0&id=71227061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71227061",
  null
  
)

export default component.exports